
export const hoverImageData = ["08.jpg", "09.jpg", "010.jpg", "011.jpg"];
export const galleryData = ["01.jpg", "02.jpg", "03.jpg", "04.jpg", "05.jpg", "06.jpg", "07.jpg", "08.jpg", "09.jpg", "010.jpg", "011.jpg", "012.jpg"];
